import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PresentationDeck from "@/components/PresentationDeck";
import ParentGuide from "@/components/ParentGuide";
import AcademyRegistration from "@/components/AcademyRegistration";
import RegistrationHub from "@/components/RegistrationHub";
import TrialSignUp from "@/components/TrialSignUp";
import EventRegistration from "@/components/EventRegistration";
import EventSuccess from "@/components/EventSuccess";
import EventCancelled from "@/components/EventCancelled";
import AcademySuccess from "@/components/AcademySuccess";
import { CampsHubPage, TournamentsHubPage } from "@/components/EventsHubPage";
import ChatBot from "@/components/ChatBot";
import { TurnstileProvider } from "@/providers/TurnstileProvider";

function App() {
  return (
    <TurnstileProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PresentationDeck />} />
          <Route path="/register" element={<RegistrationHub onBack={() => window.location.href = '/'} />} />
          <Route path="/parent-guide" element={<ParentGuide onBack={() => window.location.href = '/'} />} />
          <Route path="/register-academy" element={<AcademyRegistration onBack={() => window.location.href = '/register'} />} />
          <Route path="/academy-success" element={<AcademySuccess />} />
          <Route path="/free-trial" element={<TrialSignUp />} />
          <Route path="/event/:slug" element={<EventRegistration />} />
          <Route path="/event-success" element={<EventSuccess />} />
          <Route path="/event-cancelled" element={<EventCancelled />} />
          <Route path="/camps" element={<CampsHubPage />} />
          <Route path="/tournaments" element={<TournamentsHubPage />} />
        </Routes>
        <ChatBot />
      </BrowserRouter>
    </TurnstileProvider>
  );
}

export default App;
